import { merge } from 'lodash';
import type { Resolvers } from '../../../../generated';
import { defaultUserPrefs, userPrefsMap } from '../user-prefs';

export const resolvers: Resolvers = {
  Mutation: {
    setUserPrefs: (_, vars) => {
      const userPrefs = userPrefsMap.get(vars.userId);
      const mergedDefaultAndUserAndArgsPrefs = merge(
        { id: vars.userId, __typename: 'UserPrefs' },
        defaultUserPrefs,
        userPrefs,
        vars.userPrefs
      );

      userPrefsMap.set(vars.userId, mergedDefaultAndUserAndArgsPrefs);

      return mergedDefaultAndUserAndArgsPrefs;
    },
  },
};
